"use client";

import { useEffect } from "react";
import { getSiteHeaderElement, syncStickyHeaderHeight } from "@/app/utils/stickyHeader";

/**
 * Keeps `--header-height` in sync with the live site header. The lifestyle
 * filter bar and scroll jumps both depend on that variable, and the header
 * grows when the ribbon or impersonation banner appears after the API loads.
 */
export default function useSyncHeaderHeight() {
  useEffect(() => {
    syncStickyHeaderHeight();

    window.addEventListener("resize", syncStickyHeaderHeight);

    const header = getSiteHeaderElement();
    if (!header) {
      return () => window.removeEventListener("resize", syncStickyHeaderHeight);
    }

    const observer = new MutationObserver(syncStickyHeaderHeight);
    observer.observe(header, { childList: true, subtree: true, attributes: true });

    const timeout = setTimeout(syncStickyHeaderHeight, 1500);

    return () => {
      clearTimeout(timeout);
      observer.disconnect();
      window.removeEventListener("resize", syncStickyHeaderHeight);
    };
  }, []);
}
